import type { ApiCredentialsProperties } from '@repo/api-gw-sdk';

import type { Step } from '@/components/wizard/Step';

import { ApiCredentialsNameSelection } from './apiCredentialsNameSelection';
import { ApiCredentialsScopesSelection } from './apiCredentialsScopesSelection';
import { ApiCredentialsTokenReveal } from './apiCredentialsTokenReveal';

export type UpsertApiCredentialsState = ApiCredentialsProperties & {
  clientSecret?: string;
  clientId?: string;
};

export const UpsertApiCredentialsFlow: Step<UpsertApiCredentialsState> = {
  id: 'name_selection',
  Component: ApiCredentialsNameSelection,
  nonReturnable: true,
  next: [
    {
      id: 'scopes_selection',
      Component: ApiCredentialsScopesSelection,
      next: [
        {
          id: 'token_reveal',
          Component: ApiCredentialsTokenReveal,
        },
      ],
    },
  ],
};
